import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  appendParamsToUrl(requestUrl: string, filters: FilterMetricsParams) {
    const { location, dates, baseYear, assets, labels } = filters
    const cid = localStorage.getItem('cid')
    const { reporting_period, start_date, end_date } = dates || {}
    let url = `${requestUrl}?company_id=${cid}`

    if (baseYear !== undefined) {
      url = `${url}&base_year_toggle=${baseYear}`
    }
    if (location) {
      url = `${url}&region_code=${location}`
    }
    if (reporting_period?.toLowerCase() === 'custom') {
      url = `${url}&reporting_period=Custom&custom_start_date=${start_date}&custom_end_date=${end_date}`
    }
    else if (start_date && end_date) {
      url = `${url}&reporting_period=${reporting_period}`
    }
    if (assets && assets.length && !location) {
      url = `${url}&assets=${assets}`
    }
    if (labels && labels.length) {
      url = `${url}&labels=${labels}`
    }
    return url
  },
  async companyScopeEmissions(params: FilterMetricsParams) {
    const url = this.appendParamsToUrl(
      '/v1/metrics/total-emissions-scopewise/',
      params,
    )
    return axios.get(url)
  },
  async companyPollutantTrends(params: FilterMetricsParams) {
    const url = this.appendParamsToUrl(
      '/v1/metrics/pollutant-emissions-trend/',
      params,
    )
    return await axios.get(url)
  },
  async monthlyScopeEmissions(params: FilterMetricsParams) {
    const url = this.appendParamsToUrl(
      '/v1/metrics/monthly-emissions-scopewise/',
      params,
    )
    const scopeSeriesData = await axios.get(url).then(({ data }) => data)
    const totalEmissionsData = await this.companyScopeEmissions(params).then(({ data }) => data)

    return { scopeSeriesData, totalEmissionsData }
  },
  reportingPeriodRanges(companyId: number | string) {
    return axios.get(`/v1/metrics/reporting-periods/?company_id=${companyId}`)
  },
  scopeEmissionsOvertime(params: FilterMetricsParams) {
    const url = this.appendParamsToUrl('/v1/metrics/scopes-monthly-emissions/', params)
    return axios.get(url)
  },
  categoryEmissionsOvertime(params: FilterMetricsParams) {
    const url = this.appendParamsToUrl('/v1/metrics/categories-monthly-emissions/', params)
    return axios.get(url)
  },
  getDashboardSummary(params: DashboardDataFilterParams) {
    return axios.get<GetDashboardSummaryResponse>('/v1/metrics/dashboard-summary/', { params })
  },
  getDashboardEmissionIntensity(params: DashboardDataFilterParams) {
    return axios.get<GetDashboardEmissionIntensityResponse>('/v1/metrics/emission-intensity/', { params })
  },
  getDashboardEmissionByCategory(params: DashboardDataFilterParams) {
    return axios.get<GetDashboardEmissionByCategoryResponse>('/v1/metrics/emissions-by-category/', { params })
  },
  getDashboardEmissionByAsset(params: DashboardDataFilterParams) {
    return axios.get<GetDashboardEmissionByAssetResponse>('/v1/metrics/emissions-by-asset/', { params })
  },
  getDashboardEmissionOverTime(params: DashboardDataFilterParams) {
    return axios.get<GetDashboardEmissionOverTimeResponse>('/v1/metrics/emissions-overtime/', { params })
  },
  getMonthlyScopeEmissions(params: DashboardDataFilterParams) {
    return axios.get('/v1/metrics/monthly-emissions-scopewise/', { params })
  },
})
